import React from 'react'
import 
{
    CImg
} from '@coreui/react'

export default function Loading() {
    const style={
        margin: '50px',
        height: '100px',
    }
    return (
        
        <div className="text-center" >
            <CImg src={'loading.gif'} alt="Loading..."  style={style}/>
        </div>
    )
}
